import React from 'react';
import { Link, LinkProps, useLocation, useNavigate } from 'react-router-dom';

export type Props = {
  to: string;
  children?: React.ReactNode;
  forceUpdate?: boolean;
  preserveQueryParams?: boolean;
  onClick?: (t: any) => void;
  'aria-label'?: string;
} & LinkProps;

export default function WrappedLink(props: Props) {
  const {
    to,
    children,
    onClick,
    className,
    forceUpdate,
    preserveQueryParams,
    ...rest
  } = props;
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = search && preserveQueryParams ? search : '';
  return (
    <Link
      aria-label={props['aria-label']}
      className={className}
      onClick={e => {
        if (e.metaKey || e.ctrlKey) {
          return;
        }
        e.preventDefault();
        const {
          location: { protocol, host },
        } = window;
        if (onClick) {
          onClick(e);
        }
        const baseUrl = `${protocol}//${host}`;
        if ((window as any).swUpdate || forceUpdate) {
          window.location.href = `${baseUrl}${to}${queryParams}`;
          return;
        }
        navigate(`${to}${queryParams}`);
      }}
      to={`${to}${queryParams}`}
      {...rest}
    >
      {children}
    </Link>
  );
}
